export default __webpack_public_path__ + "static/media/offer3.edf412ee.jpg";